import { createSlice } from '@reduxjs/toolkit';
import { keyBy } from 'lodash';
import { getCPCBLog } from './downTimeThunk';
const initialState = {
  message: '',
  recyclers: {},
  startTime: '',
  downTimeLogsMap: {},
};

export const downTimeSlice = createSlice({
  name: 'downtime',
  initialState,
  reducers: {
    handleDownTime: (state, action) => {
      const { downTime, message, startTime } = action.payload;
      state.hasDownTime = downTime;
      state.message = message;
      state.startTime = startTime;
      state.endTime = endTime;
    },
    resetDownTime: (state) => {
      state.hasDownTime = false;
      state.message = '';
    },
    handleDownTimeRecyclers: (state, action) => {
      state.recyclers = action.payload;
    },
    resetDownTimeRecyclers: (state) => {
      state.recyclers = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCPCBLog.fulfilled, (state, action) => {
      const modifiedData = action.payload?.map((item) => {
        return {
          ...item,
          hasDownTime: item.isActive,
        };
      });
      state.downTimeLogsMap = keyBy(modifiedData, 'customerId');
    });
  },
});

export const { handleDownTime, resetDownTime, handleDownTimeRecyclers, resetDownTimeRecyclers } =
  downTimeSlice.actions;

export default downTimeSlice.reducer;
